import React, { useEffect, useMemo, useState } from 'react';
import { Input, Spin, Alert, Button, message } from 'antd';
import { nanoid } from 'nanoid';
import { Map, Marker, Label, APILoader, Polyline } from '@uiw/react-baidu-map';
import { askLLMForResult, askLLMForCord } from '../utils/llm'
import './drag2map.css'
import LocModal from './locmodal.jsx'
import LocBaseModal from './locBaseModal.jsx'
import AddAddressModal from './addAddressModal.jsx'
import { openDB, getDataByKey } from './indexedDB.js'

const { TextArea } = Input;

var db;
const Drag2Map = (props) => {
	const [center, setCenter] = useState({});
	const [result, setResult] = useState("");
	const [dataSource, setDataSource] = useState([]);
	const [asking, setAsking] = useState(false);
	const [icons, setIcons] = useState({});
	const [lines, setLines] = useState({});
	const [forceRender, setForceRender] = useState(0);

	const [showingModal, setShowingModal] = useState(false);
	const [showingLocBaseModal, setShowingLocBaseModal] = useState(false);

	const [showingAddAddressModal, setShowingAddAddressModal] = useState(false);
	const [pointLat, setPointLat] = useState(0);
	const [pointLon, setPointLon] = useState(0);

	useEffect(() => {
		openDB("panelDB").then(res => { db = res })
	}, [])

	useEffect(() => {
		if (result) {
			const lines = result.split("\n");
			if (lines.length > 0) {
				setDataSource(lines.map((line) => {
					const items = line.split("|");
					if (items.length > 2) {
						return {
							id: nanoid(),
							name: items[0],
							type: items[1],
							loc: items[2],
						}
					}
				}));
			} else {
				setDataSource([]);
			}
		}
	}, [result]);

	const submit = async (text) => {
		setResult("")
		const prompt = [
			{
				"role": "system", "content": `你是一个文本内容抽取助手，请从我输入的文本中抽取出目标名称、类型、位置等内容，形成以'|'分隔的csv表格，不要表头，csv数据之外不要添加任何额外字符。
				其中，“类型”仅限从飞机和舰船二者中选择，如果没有合适的，请填“其它”。
				例如：对于输入信息“一架A-320在经巴士海峡至三亚活动，1艘扫雷艇在冲绳附近活动。”，则输出“A-320|飞机|巴士海峡,三亚\n扫雷艇|舰船|冲绳”。
				输入信息为：` },
			{ "role": "user", "content": text }
		]
		await askLLMForResult(props.model, prompt, setResult, setAsking);
		setShowingModal(true);
	}

	const tomap = (cords) => {
		setShowingModal(prev => !prev)
		setForceRender(prev => prev + 1);
		setIcons({});
		setLines({});
		var tempCenter = {};
		dataSource?.forEach((item) => {
			const { name, type } = item
			const id = item.id
			const locs = item.loc.replaceAll("，", ",").split(",").map(e => e.trim());
			const path = []
			locs.forEach((loc, index) => {
				if (cords[loc]) {
					const { lat, lon } = cords[loc];
					path.push({ lng: lon, lat: lat, loc: loc });
					// 轨迹最后一个点
					if (index === locs.length - 1) {
						setIcons(prev => {
							return {
								...prev,
								[id]: {
									name: name,
									type: type,
									lat: lat,
									lng: lon,
									loc: loc
								}
							}
						})
						tempCenter = { lat: lat, lng: lon };
					}
				}
			})
			setLines(prev => ({ ...prev, [id]: path }))
		})
		// 设置屏幕中心点为最后一个目标轨迹的最后一个点
		setCenter(tempCenter);
	}

	const handleDrop = (e) => {
		e.preventDefault();
		if (e.dataTransfer.items[0].kind === "string") {
			const text = e.dataTransfer.getData("Text");
			if (text) {

				submit(text);
			}
		}
	}

	const handleRightClick = (e) => {
		const { lat, lng } = e.point;
		setPointLat(lat);
		setPointLon(lng);
		setCenter({ lng: lng, lat: lat })
		setShowingAddAddressModal(true);
	}

	return (
		<>
			<div className='tabPage'>
				<span className='tip'>请将标图依据的文本拖拽至地图</span>
				<Button className='locBaseButton' size='small' style={{ visibility: showingModal ? 'hidden' : 'visible' }} onClick={() => { setShowingLocBaseModal(true) }}>地名库管理</Button>
				<div className={asking ? "spinContent" : "spinContentHidden"}>
					<Spin tip="大模型抽取中..." size='large'>
						<div style={{ padding: '50px', borderRadius: '4px' }}></div>
					</Spin>
				</div>
				<div className='mapDiv' onDrop={handleDrop} onDragOver={(e) => { e.preventDefault() }}>
					<APILoader akay="PBY8a0Srye77leaBnETSUiuGGmARNiTj">
						<Map key={forceRender} center={Object.keys(center).length === 0 ? { lng: 115, lat: 15 } : center} zoom={6}
							onRightClick={handleRightClick}
							ref={(props) => {
								if (props && props.map) {
									// 启用滚轮放大缩小，默认禁用
									props.map.enableScrollWheelZoom();
								}
							}}>
							{Object.keys(icons).map(key =>
								<Marker key={key} position={{ lat: icons[key].lat, lng: icons[key].lng }}
									type="loc_red" title={icons[key].name} />
							)}
							{Object.keys(icons).map(key =>
								<Label key={key} position={{ lat: icons[key].lat, lng: icons[key].lng }}
									content={icons[key].name + "（" + icons[key].loc + "）"} />
							)}
							{Object.keys(lines).map((key) => <Polyline key={key} path={lines[key]} />)}
							{Object.keys(lines).map((key) => {
								console.log(lines[key])
								if (lines[key].length > 0) {
									return lines[key].slice(0, lines[key].length - 1).map((p, i) => <Label key={i} position={{ lat: p.lat, lng: p.lng }} content={p.loc} />)
								}
							})}
						</Map>
					</APILoader>
				</div>
			</div>
			<LocModal db={db} scroll={{ y: '60dvh' }} model={props.model} showing={showingModal} setShowing={setShowingModal} tomap={tomap}
				dataSource={dataSource} setDataSource={setDataSource} />
			<LocBaseModal db={db} showing={showingLocBaseModal} setShowing={setShowingLocBaseModal} />
			<AddAddressModal db={db} showing={showingAddAddressModal} setShowing={setShowingAddAddressModal} lat={pointLat} lon={pointLon} />
		</>
	)
}

export default Drag2Map;